<template>
        <div>
            <div class="header">
                <a :class="{ clickanim: bounce }" href="" @click="handleClick($event,'Home')">{{ title }}</a>
                <a v-for="s in sections" href="makelink(s)" :key="s" @click="handleClick($event,s)">{{ s }}</a>
                <a href="" class="icon" @click="handleMenuClick($event)">
                  <font-awesome-icon :icon="faBars" />
                </a>
            </div>
            <transition name='mnuanim'>
              <div v-on-clickaway="away" class='menuwrapper' v-show="menuVisible">
                  <div class='headermenu'>
                      <div class='menuitem' v-for="s in sections" :key="s" @click="handleClick($event,s)">
                        {{ s }}
                      </div>
                  </div>
              </div>
            </transition>
        </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faBars from '@fortawesome/fontawesome-free-solid/faBars'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],

  props: ['title', 'sections', 'onGotoSection'],
  data () {
    return {
      menuVisible: false,
      faBars,
      bounce: false
    }
  },

  components: { FontAwesomeIcon },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },

  mounted () {
    window.addEventListener('resize', this.handleResize)
  },

  methods: {
    away () {
      this.menuVisible = false
    },
    handleResize () {
      this.menuVisible = false
    },
    handleClick (ev, s) {
      ev.stopPropagation()
      ev.preventDefault()
      this.menuVisible = false
      const ref = this.makelink(s)
      this.$emit('onGotoSection', ref.slice(1))
      if (ref === '#home') {
        this.bounce = true
        setTimeout(this.bounceReset, 1000)
      }
    },
    bounceReset () {
      this.bounce = false
    },
    handleMenuClick (ev) {
      ev.stopPropagation()
      ev.preventDefault()
      this.menuVisible = !this.menuVisible
    },
    makelink (s) {
      return `#${s.replace(/ /g, '').toLowerCase()}`
    }
  }
}
</script>

<style lang="less" scoped>
@import "../css/globals.less";

.menuwrapper {
  display: block;
  position: fixed;
  top: 48pt;
  left: 0;
  max-height: 260pt;
  overflow: hidden;
  opacity: 1;
  right: 0;
  z-index: 10001;
}
.mnuanim-enter-active,
.mnuanim-leave-active {
  // transition: opacity ease-in 3s, top ease-in 3s, max-height ease-in .3s;
  transition: opacity linear 0.2s, max-height linear 0.2s;
}

.mnuanim-enter,
.mnuanim-leave-to {
  opacity: 0.5;
  // top: -100%;
  max-height: 0;
}

.mnuanim-enter-to,
.mnuanim-leave {
  opacity: 1;
  // top: 48pt;
  max-height: 260pt;
}

.header {
  overflow: hidden;
  background-color: rgb(92, 71, 32);
  font-family: @serif-font, "Open Sans";
  font-weight: 300;
  opacity: 0.75;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 48pt;
  display: flex;
  z-index: 1000;
}

.clickanim {
  animation: clickanimframes 1s ease-in-out;
}

@keyframes clickanimframes {
  0% {
  }
  50% {
    transform: scale(1.1);
  }
  100% {
  }
}

.header a {
  flex: 1 1 0;
  display: block;
  color: #f2f2f2;
  text-align: center;
  padding: 0 0;
  text-decoration: none;
  font-size: 13.5pt;
  height: 48pt;
  line-height: 48pt;
  align-items: center;
  /* border: solid 1px red; */
}

.header a:first-child {
  font-family: @cursive-font;
  padding: 0 0.5em;
  margin: 0;
  font-size: @default-font-size * 1.5;
  line-height: 48pt;
  white-space: nowrap;
}

.header h1 {
  font-family: @cursive-font;
  font-weight: normal;
  padding: 0;
  margin: 0;
  font-size: @default-font-size * 1.5;
  line-height: 48pt;
}

.header a:not(:first-child):hover {
  background-color: rgb(131, 81, 15);
  color: black;
  transform: scale(1.2);
  transition: transform 0.3s ease-in-out;
}

.header a.icon {
  display: none;
  padding: 0 1em;
}

.headermenu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(75, 57, 23, 0.918);
}

.headermenu > .menuitem {
  flex: 0 1 0;
  cursor: pointer;
  color: white;
  font-family: @serif-font, "Open Sans";
  font-size: 16pt;
  font-weight: 300;
  text-decoration: none;
  line-height: 48pt;
  height: 48pt;
}

.headermenu > .menuitem:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}

@media screen and (max-width: 1020px) {
  .header a:not(:first-child) {
    display: none;
  }
  .header a.icon {
    flex: 0 1 0;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue